export const calcTickPositions = (min, max) => {
  let tickInterval = 0
  let minTopTickDistance = max - min

  const d = min !== Math.round(min) || max !== Math.round(max) ? 100 : 1

  if (d * (max - min) < 8) {
    tickInterval = 1
  } else {
    for (let tii = 0; tii <= 15; tii++) {
      const topTickDistance = Math.ceil((d * (max - min)) / (10 - tii)) * (10 - tii) - Math.ceil(d * (max - min))
      if (topTickDistance >= 0 && topTickDistance < minTopTickDistance) {
        minTopTickDistance = topTickDistance
        tickInterval = Math.ceil((d * (max - min)) / (10 - tii))
      }
    }
    if (tickInterval === 0) {
      tickInterval = Math.round((d * (max - min)) / 7)
    }
  }
  tickInterval = tickInterval / d

  const tickPositions = [min]
  while (tickPositions[tickPositions.length - 1] + tickInterval < max) {
    tickPositions.push(parseFloat((tickPositions[tickPositions.length - 1] + tickInterval).toFixed(2)))
  }
  tickPositions.push(max)

  return tickPositions
}

// zoomLevel → extremes: 'min' = best fit, 'max' = full scale, [min, max] = drag-select range
export const resolveZoomExtremes = (zoomLevel, best, full) => {
  if (Array.isArray(zoomLevel)) return { min: zoomLevel[0], max: zoomLevel[1] }
  if (zoomLevel === 'max') return { min: full.min, max: full.max }
  return { min: best.min, max: best.max } // 'min' / default
}

export const calcMinMax = (data, percentsMode, options = {}) => {
  const { answer = {}, rType, yAxisLimits, zoomType, minYValue: _minYValue, maxYValue: _maxYValue } = options

  let minYValue = _minYValue || 0
  let maxYValue = _maxYValue || 0

  if (Array.isArray(yAxisLimits) && yAxisLimits.length === 2) {
    minYValue = Math.max(minYValue, yAxisLimits[0])
    maxYValue = Math.min(maxYValue, yAxisLimits[1])

    data.yAxis.min = yAxisLimits[0]
    data.yAxis.max = yAxisLimits[1]
  } else {
    data.yAxis.min = Math.min(data.yAxis.min, percentsMode ? (data.yAxis.min < 0 ? -100 : 0) : data.yAxis.min)
    data.yAxis.max =
      data.yAxis.min < 0
        ? Math.max(data.yAxis.max, Math.abs(data.yAxis.min))
        : Math.max(
            data.yAxis.max,
            percentsMode ? 100 : rType == null || rType === 'cases' ? answer.total || 0 : answer.respTotal || 0
          )
  }

  data.yAxis.min = data.yAxis.min < 0 ? -Math.ceil(Math.abs(data.yAxis.min)) : Math.floor(data.yAxis.min)
  data.yAxis.max = Math.ceil(data.yAxis.max)

  data.yAxis.tickPositions = calcTickPositions(data.yAxis.min, data.yAxis.max)
  if (zoomType) {
    data.yAxis.startOnTick = false
    data.yAxis.endOnTick = false
  }

  return { minYValue, maxYValue }
}
